/*********************** Custom JS for Boost AI Search & Discovery  ************************/

(() => {
  const boostRecommendationSelector = '[id^="boost-sd-widget-"]';
  let scheduledFrame = null;

  const enhanceRecommendationCarousels = () => {
    document.querySelectorAll(boostRecommendationSelector).forEach((root) => {
      root.querySelectorAll('.slick-dots').forEach((pagination) => {
        pagination.setAttribute('aria-label', 'Recommendation carousel pagination');

        const buttons = Array.from(pagination.querySelectorAll('button'));
        buttons.forEach((button, index) => {
          button.setAttribute('aria-label', `Go to recommendation slide ${index + 1} of ${buttons.length}`);

          if (button.closest('li')?.classList.contains('slick-active')) {
            button.setAttribute('aria-current', 'true');
          } else {
            button.removeAttribute('aria-current');
          }
        });
      });

      root.querySelectorAll('.boost-sd__prev-button-icon').forEach((icon) => {
        icon.closest('button')?.setAttribute('aria-label', 'Previous recommendation slide');
      });
      root.querySelectorAll('.boost-sd__next-button-icon').forEach((icon) => {
        icon.closest('button')?.setAttribute('aria-label', 'Next recommendation slide');
      });
    });
  };

  const scheduleEnhancement = () => {
    if (scheduledFrame !== null) return;
    scheduledFrame = requestAnimationFrame(() => {
      scheduledFrame = null;
      enhanceRecommendationCarousels();
    });
  };

  const start = () => {
    scheduleEnhancement();
    new MutationObserver(scheduleEnhancement).observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class']
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
